<template>
  <div class="allience">
    <div class="choose-state">
      <span
        v-for="(choose, index) in chooses"
        :key="choose.name"
        @click="active(index, choose.name)"
        :class="isClass == index ? 'choose' : ''"
        >{{ choose.name }}</span
      >
    </div>
    <div class="banner">
      <img :src="banners[isClass].imgUrl" alt />
    </div>
    <!-- 党务服务 -->
    <div class="preferentital-service" v-show="isClass == 0">
      <template v-if="msgs.length != 0">
        <div
          class="preferentital-service-template"
          v-for="(msg, index) in msgs"
          :key="index"
        >
          <!-- <p v-text="(index+1+'.') + msg.headline"></p>
        <p>{{msg.createtime | times}}</p> -->
          <p v-html="msg.memo"></p>
        </div>
      </template>
      <div v-else>
        <noneBox />
      </div>
    </div>
    <!-- 政务服务 -->
    <div class="learn-to-teach" v-show="isClass == 1">
      <template v-if="msgs.length != 0">
        <div
          class="preferentital-service-template"
          v-for="(msg, index) in msgs"
          :key="index"
        >
          <!-- <p v-text="(index+1+'.') + msg.headline"></p>
        <p>{{msg.createtime | times}}</p> -->
          <p v-html="msg.memo"></p>
        </div>
      </template>
      <div v-else>
        <noneBox />
      </div>
    </div>
    <!-- 商务服务 -->
    <div class="convenient-consulting" v-show="isClass == 2">
      <template v-if="msgs.length != 0">
        <div
          class="preferentital-service-template"
          v-for="(msg, index) in msgs"
          :key="index"
        >
          <!-- <p v-text="(index+1+'.') + msg.headline"></p>
        <p>{{msg.createtime | times}}</p> -->
          <p v-html="msg.memo"></p>
        </div>
      </template>
      <div v-else>
        <noneBox />
      </div>
    </div>
    <!-- 社区服务 -->
    <div class="other-serve" v-show="isClass == 3">
      <template v-if="msgs.length != 0">
        <div
          class="preferentital-service-template"
          v-for="(msg, index) in msgs"
          :key="index"
        >
          <!-- <p v-text="(index+1+'.') + msg.headline"></p>
        <p>{{msg.createtime | times}}</p> -->
          <p v-html="msg.memo"></p>
        </div>
      </template>
      <div v-else>
        <noneBox />
      </div>
    </div>
    <!-- 志愿服务 -->
    <div class="other-serve" v-show="isClass == 4">
      <template v-if="msgs.length != 0">
        <div
          class="preferentital-service-template"
          v-for="(msg, index) in msgs"
          :key="index"
        >
          <!-- <p v-text="(index+1+'.') + msg.headline"></p>
        <p>{{msg.createtime | times}}</p> -->
          <p v-html="msg.memo"></p>
        </div>
      </template>
      <div v-else>
        <noneBox />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chooses: [
        { name: "党务服务" },
        { name: "政务服务" },
        { name: "商务服务" },
        { name: "社区服务" },
        { name: "志愿服务" },
      ],
      isClass: 0,
      banners: [
        {
          imgUrl: require("@/assets/twoStar/dangwu.png"),
          index: 0,
        },
        {
          imgUrl: require("@/assets/twoStar/zhengwu.png"),

          index: 1,
        },
        {
          imgUrl: require("@/assets/twoStar/shangwu.png"),

          index: 2,
        },
        {
          imgUrl: require("@/assets/twoStar/shequ.png"),
          index: 3,
        },
        {
          imgUrl: require("@/assets/twoStar/zhiyuan.png"),
          index: 4,
        },
      ],
      msgs: [],
      type: ''
    };
  },
  created() {
    this.type = this.$route.query.typeName
  },
  methods: {
    active(index, name) {
      this.isClass = index;
      this.getMsg(name);
    },
    getMsg(name) {
      // this.axios
        // .get(`/api/Main/ActivityList?typename=华陆大厦综合党委&name=${name}&title=资源服务`)
      this.axios({
        method: 'get',
        url: '/api/Main/ActivityList',
        params: {
          typename: this.type == 'hualu' ? '华陆大厦综合党委' : '东坡水街商圈综合党委',
          name: name,
          title: '资源服务'
        }
      }).then((e) => {
        // console.log(e.data);
        switch (e.data.code) {
          case 0:
            this.msgs = e.data.msg;
            break;

          default:
            this.msgs = [];
            break;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    },
    // geDetail(id){
    //    this.$router.push({
    //     path: "publicDetail",
    //     query: { title: "新闻动态", id: id, dbnum: 1 }
    //   });
    // }
  },
  mounted() {
    this.getMsg("党务服务");
  },
};
</script>

<style lang="scss" scoped>
.allience {
  .learn-to-teach,
  .convenient-consulting,
  .other-serve,
  .preferentital-service {
    .preferentital-service-template {
      p {
        &:nth-child(1) {
          font-weight: bold;
          line-height: 2;
        }
        &:nth-child(2) {
          line-height: 1.5;
          color: #999999;
        }
      }
      margin-top: 0.3rem;
    }
    width: 94%;
    margin: 0.3rem auto;
  }
  .banner {
    img {
      width: 94%;
    }
    text-align: center;
    margin-top: 0.2rem;
  }
  .choose-state {
    span {
      width: 25%;
    }
    .choose {
      font-weight: bold;
      color: #ffa000;
    }
    align-items: center;
    color: #999999;
    display: flex;
    text-align: center;
    width: 100%;
    overflow-x: scroll;
    background: #fff;
    line-height: 3;
  }
  font-size: 0.3rem;
  padding-top: 1rem;
}
</style>